import React from 'react';
import './pages.css';

const Services = () => {
  return (
    <div className="services-container">
      {/* Hero Section */}
      <div className="services-hero">
        <div className="services-hero-content">
          <h1>Our Services</h1>
          <p>Delivering innovative visualization and BIM software solutions since 2005</p>
        </div>
      </div>

      {/* Main Services Section */}
      <div className="services-main">
        <div className="services-content">
          
          {/* Road Safety Audit 3D */}
          <div className="service-section">
            <div className="service-header">
              <h2>Road Safety Audit 3D Technology</h2>
              <div className="service-badge">Safety Analysis</div>
            </div>
            <div className="service-content">
              <div className="service-description">
                <p>
                  Our revolutionary Road Safety Audit 3D tool uses a systemic approach to identify safety 
                  deficiencies in 3D environments. This innovative tool allows designers to accurately 
                  predict accidents beyond just using historical crash data.
                </p>
                <div className="service-features">
                  <h3>Key Features:</h3>
                  <ul>
                    <li>3D environment safety analysis</li>
                    <li>Accident prediction capabilities</li>
                    <li>Systemic approach to safety audits</li>
                    <li>Works for both new and existing roads</li>
                    <li>Accurate data and insights</li>
                    <li>Identifies potentially hazardous road sections</li>
                  </ul>
                </div>
                <div className="service-benefits">
                  <h3>Benefits:</h3>
                  <ul>
                    <li>Proactive safety assessment</li>
                    <li>Reduced accident rates</li>
                    <li>Cost-effective safety solutions</li>
                    <li>Enhanced public safety</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* 123BIM Visualization */}
          <div className="service-section">
            <div className="service-header">
              <h2>123BIM Visualization Platform</h2>
              <div className="service-badge">3D Visualization</div>
            </div>
            <div className="service-content">
              <div className="service-description">
                <p>
                  123BIM seamlessly converts complex project designs from any industry-standard CAD 
                  platform into 3D digital models. These models can be uploaded to the cloud for 
                  collaboration and public engagement.
                </p>
                <div className="service-features">
                  <h3>Platform Components:</h3>
                  <ul>
                    <li><strong>123BIM Navigator:</strong> Interactive project navigation</li>
                    <li><strong>123BIM Virtual Tour:</strong> Immersive project exploration</li>
                    <li><strong>3D Project Modeling:</strong> Detailed design visualization</li>
                    <li><strong>Photorealism:</strong> High-quality visual representation</li>
                  </ul>
                </div>
                <div className="service-benefits">
                  <h3>Benefits:</h3>
                  <ul>
                    <li>Seamless CAD integration</li>
                    <li>Cloud-based collaboration</li>
                    <li>Public engagement tools</li>
                    <li>Real-time project updates</li>
                    <li>Cross-platform accessibility</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Rapid Delivery */}
          <div className="service-section">
            <div className="service-header">
              <h2>Rapid Delivery Times</h2>
              <div className="service-badge">Efficiency</div>
            </div>
            <div className="service-content">
              <div className="service-description">
                <p>
                  We value your time. Our turnaround for data is just a week or two, delivering 
                  quickly and punctually. Our "Publish, Don't Render" motto pushes the boundaries 
                  of innovation while drastically reducing delivery times.
                </p>
                <div className="delivery-stats">
                  <div className="stat-item">
                    <h3>1-2 Weeks</h3>
                    <p>Typical project turnaround</p>
                  </div>
                  <div className="stat-item">
                    <h3>19+ Years</h3>
                    <p>Combined leadership experience</p>
                  </div>
                  <div className="stat-item">
                    <h3>50+</h3>
                    <p>State DOTs and agencies served</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Client Testimonials */}
          <div className="testimonials-section">
            <h2>What Our Clients Say</h2>
            <div className="testimonials-grid">
              <div className="testimonial-card">
                <div className="testimonial-content">
                  <p>"The RDV models were the star of the show and made it possible for our team to share an extremely complex proposal with the public, in a way that was easily understood."</p>
                </div>
                <div className="testimonial-author">
                  <strong>Connecticut DOT</strong>
                </div>
              </div>
              
              <div className="testimonial-card">
                <div className="testimonial-content">
                  <p>"RDV provided highly effective presentation materials that awed all who saw them. RDV was a pleasure to work with. They provided a very high quality product at a very reasonable cost, on time and within budget."</p>
                </div>
                <div className="testimonial-author">
                  <strong>Maine DOT</strong>
                </div>
              </div>
              
              <div className="testimonial-card">
                <div className="testimonial-content">
                  <p>"As soon as we opened the RDV model the level of hostility in the room dropped by 80%."</p>
                </div>
                <div className="testimonial-author">
                  <strong>North Carolina DOT</strong>
                </div>
              </div>
            </div>
          </div>

          {/* Call to Action */}
          <div className="services-cta">
            <h2>Ready to Get Started?</h2>
            <p>Contact us to discuss how RDV Systems can help with your next project</p>
            <div className="cta-buttons">
              <a href="/contact" className="cta-button primary">Contact Us</a>
              <a href="/about" className="cta-button secondary">Learn More</a>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Services;
